import { useEffect, useState } from "react";
import DirectRewardsRedemptionOutcome from "../../../../components/campaign/rulesAndOutcomes/outcomes/directRewardsRedemption/DirectRewardsRedemptionOutcome";
import StreakConfigView from "../../../../components/campaign/viewComponents/StreakConfigView";
import ViewComponentsRenderer from "../../../../components/campaign/viewComponents/ViewComponentsRenderer";
import LeaderboardOutcomeSummary from "./LeaderboardOutcomeSummary";
import RewardGroupOutcomes from "./RewardGroupOutcomes";
import RewardOutcome from "./RewardOutcome";
import SummaryCard from "./SummaryCard";
import RewardAllocationOutcomeSummary from "./RewardAllocationOutcomeSummary";

const CampaignOutcomes = ({
  isViewScreen,
  handleOutcomesEditSection,
  campaignStateData,
}) => {
  const [outcomes, setOutcomes] = useState([]);
  const rewardGroupsSlugs = [
    "participate-in-journey",
    "direct-rewards",
    "participate-in-journey-reward-selection",
  ];
  useEffect(() => {
    if (
      campaignStateData?.outcomes?.length &&
      campaignStateData?.outcomes?.[0]?.outcomeDefinition?.slug?.indexOf("journey") >
        -1 &&
      campaignStateData?.outcomes?.[0]?.outcomeData?.reward_group_ids?.length
    ) {
      setOutcomes(
        campaignStateData?.outcomes?.[0]?.outcomeData?.reward_group_ids?.map(
          (id) => ({
            outcomeData: { reward_group_id: id },
            outcomeDefinition: campaignStateData?.outcomes?.[0]?.outcomeDefinition,
            outcomeRules: [],
          })
        )
      );
    } else {
      setOutcomes(campaignStateData.outcomes);
    }
  }, [campaignStateData.outcomes]);

  return (
    <SummaryCard
      title="Campaign Setup - Outcomes"
      isViewScreen={isViewScreen}
      handleEditSection={handleOutcomesEditSection}
    >
      {outcomes?.length > 0 &&
        outcomes.map((outcome, index) =>
          rewardGroupsSlugs.indexOf(outcome?.outcomeDefinition?.slug) === -1 ? (
            <OutcomesRenderer
              outcome={outcome}
              key={outcome?.outcomeDefinition.id}
            />
          ) : (
            <RewardGroupsOutcomesRenderer
              campaignState={campaignStateData}
              outcome={outcome}
              key={outcome?.outcomeDefinition.id}
              index={index}
            />
          )
        )}
    </SummaryCard>
  );
};

const OutcomesRenderer = ({ outcome, key }) => {
  const isDirectRewardsRedemption =
    outcome?.outcomeDefinition?.slug === "direct-redemption-rewards" ||
    outcome?.outcomeDefinition?.slug === "direct-redemption-rewards-b2b";

  const renderOutcomeContent = () => {
    const slug = outcome?.outcomeDefinition?.slug;

    if (slug === "reward-allocation-outcome") {
      return (
        <div className="additional-fields-container">
          <RewardAllocationOutcomeSummary outcome={outcome} key={outcome?.id} />
        </div>
      );
    }

    if (slug === "award-leaderboard-points") {
      return (
        <div className="additional-fields-container">
          <LeaderboardOutcomeSummary
            outcome={outcome}
            key={outcome?.outcomeData?.leaderboard_id}
          />
        </div>
      );
    }

    if (slug === "points-based-streaks") {
      return (
        <StreakConfigView
          data={outcome?.outcomeData}
          key={outcome?.outcomeData?.streak_config_id || outcome?.id}
        />
      );
    }

    if (isDirectRewardsRedemption) {
      return <DirectRewardsRedemptionOutcome outcome={outcome} />;
    }

    if (
      slug &&
      outcome?.outcomeDefinition?.inputSchema &&
      outcome?.outcomeDefinition?.uiSchema
    ) {
      return (
        <ViewComponentsRenderer
          customComponentName={slug}
          data={outcome?.outcomeData}
          inputSchema={outcome?.outcomeDefinition?.inputSchema}
          uiSchema={outcome?.outcomeDefinition?.uiSchema}
          definition={outcome}
        />
      );
    }

    return null;
  };

  return (
    <div className="outcome-card" key={key}>
      {renderOutcomeContent()}
    </div>
  );
};

const RewardGroupsOutcomesRenderer = ({ outcome, campaignState, index }) => {
  return (
    <>
      {outcome?.outcomeDefinition?.slug === "direct-rewards" ? (
        <RewardOutcome outcome={outcome} key={outcome?.outcomeDefinition.id} />
      ) : (
        <RewardGroupOutcomes
          campaignType={campaignState.type}
          outcome={outcome}
          key={outcome?.outcomeData?.reward_group_id || index}
          campaignState={campaignState}
        />
      )}
    </>
  );
};

export default CampaignOutcomes;
